<script lang="ts" setup>
import { computed } from 'vue'
import type { ChatRoomStatus } from '@/types/schema.generated'

const props = defineProps<{
  status: ChatRoomStatus
}>()

const statusAndModifierMap = {
  NotDefined: 'notDefined',
  Messaging: 'messaging',
  Offering: 'offering',
  Keeping: 'keeping',
  Appointed: 'appointed',
  ContractConcluded: 'contractConcluded',
  ContractConcludedSecurities: 'contractConcludedSecurities',
  ContractConcludedInsurance: 'contractConcludedInsurance',
  GotComplaints: 'gotComplaints',
  ActionRequired: 'actionRequired',
  LostOrder: 'lostOrder',
  Archived: 'archived',
  WaitingForFirstAppointment: 'waitingForFirstAppointment',
} as const satisfies Record<ChatRoomStatus, string>

const statusModifier = computed(() => {
  return statusAndModifierMap[props.status]
})
</script>

<template>
  <div :class="[$style.root, $style[`root--${statusModifier}`]]"></div>
</template>

<style lang="scss" module>
.root {
  width: 12px;
  height: 12px;
  border: 1px solid $color-border-low-emphasis;
  border-radius: 50%;

  // 未設定
  &--notDefined {
    background-color: $color-label-white;
  }

  // チャット対応中
  &--messaging {
    background-color: $color-label-orange;
  }

  // 面談設定中
  &--offering {
    background-color: $color-label-orange;
  }

  // 後追い対応
  &--keeping {
    background-color: $color-label-orange;
  }

  // 初回面談実施待ち
  &--waitingForFirstAppointment {
    background-color: $color-label-water;
  }

  // 面談済み・対応中
  &--appointed {
    background-color: $color-label-water;
  }

  // 契約済み
  &--contractConcluded {
    background-color: $color-label-green;
  }

  // 証券契約済み
  &--contractConcludedSecurities {
    background-color: $color-label-green;
  }

  // 保険契約済み
  &--contractConcludedInsurance {
    background-color: $color-label-green;
  }

  // 不満足の表明
  &--gotComplaints {
    background-color: $color-label-red;
  }

  // 要対応
  &--actionRequired {
    background-color: $color-label-red;
  }

  // 失注
  &--lostOrder {
    background-color: $color-label-gray;
  }

  // 対応不要
  &--archived {
    background-color: $color-label-gray;
  }
}
</style>
